var _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGerade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 760 343",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Fl\\xFCgel links",
    transform: "matrix(1,0,0,1,0,55.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pfosten links",
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "1101C",
    transform: "matrix(1.01145,0,0,1.32039,-31.0485,-64.7838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "querbalken unten",
    transform: "matrix(6.0539e-17,0.757351,-1.30518,6.12203e-17,406.394,240.235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "querbalken oben",
    transform: "matrix(6.0539e-17,0.757351,-1.30518,6.12203e-17,406.394,69.5125)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,126.019,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,151.939,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,177.845,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,203.752,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,229.658,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,255.565,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,281.556,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,307.462,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,333.369,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,359.275,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,385.182,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,411.088,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,436.994,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pfosten rechts",
    transform: "matrix(1,0,0,1,371.375,-2.84217e-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fl\\xFCgel rechts",
    transform: "matrix(1,0,0,1,380,55.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pfosten links",
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "1101C",
    transform: "matrix(1.01145,0,0,1.32039,-31.0485,-64.7838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "querbalken unten",
    transform: "matrix(6.0539e-17,0.757351,-1.30518,6.12203e-17,406.394,240.235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "querbalken oben",
    transform: "matrix(6.0539e-17,0.757351,-1.30518,6.12203e-17,406.394,69.5125)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,126.019,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,151.939,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,177.845,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,203.752,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,229.658,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,255.565,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,281.556,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,307.462,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,333.369,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,359.275,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,385.182,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,411.088,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.943246,436.994,2.08756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pfosten rechts",
    transform: "matrix(1,0,0,1,371.375,-2.84217e-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T\\xFCrgriff",
    transform: "matrix(1,0,0,1.07784,0.447253,60.5694)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,0.927783,-0.447253,-56.1953)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 384.76,
    y: 170.114,
    width: "20.54px",
    height: "40.318px",
    transform: "matrix(0.978075,0,0,0.983359,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.207752,0,0,0.254504,23.9201,-46.5718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1771.13,664.614C1757.61,671.09 1748.18,685.597 1748.18,702.437L1715.98,702.437L1715.98,588.565L1771.13,588.565L1771.13,664.614Z",
    style: {
      fill: "rgb(74,76,79)",
      stroke: "black",
      strokeWidth: "0.41px"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,0.927783,-0.447253,-56.1953)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 382.962,
    y: 175.309,
    width: "13.446px",
    height: "33.224px",
    transform: "matrix(0.960448,0,0,0.977188,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.207752,0,0,0.254504,735.819,-46.5883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1771.13,664.614C1757.61,671.09 1748.18,685.597 1748.18,702.437L1715.98,702.437L1715.98,588.565L1771.13,588.565L1771.13,664.614Z",
    style: {
      fill: "rgb(74,76,79)",
      stroke: "black",
      strokeWidth: "0.41px"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-43.6951,-25.5681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1777.75,631.73C1774.83,630.173 1772.83,627.096 1772.83,623.558C1772.83,618.451 1776.98,614.305 1782.09,614.305C1787.19,614.305 1791.34,618.451 1791.34,623.558C1791.34,627.096 1789.35,630.173 1786.43,631.73L1786.43,645.556C1786.43,646.754 1785.45,647.726 1784.26,647.726L1779.92,647.726C1778.72,647.726 1777.75,646.754 1777.75,645.556L1777.75,631.73Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Griff",
    transform: "matrix(1,-0,-0,0.927783,-0.447253,-56.1953)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 397.285,
    y: 197.126,
    width: "24.027px",
    height: "7.307px",
    transform: "matrix(0.961087,0,0,0.913343,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Griff",
    transform: "matrix(0.335661,0,0,0.24,-206.888,-40.0883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1818.97,638.414C1818.97,636.205 1817.59,634.41 1815.89,634.41L1759.9,634.41C1758.2,634.41 1756.82,636.205 1756.82,638.414L1756.82,646.422C1756.82,648.632 1758.2,650.426 1759.9,650.426L1815.89,650.426C1817.59,650.426 1818.97,648.632 1818.97,646.422L1818.97,638.414Z",
    style: {
      fill: "rgb(74,76,79)"
    }
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Trenner",
    transform: "matrix(0.0749246,0,0,0.294142,251.035,5.49568)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1710.41,
    y: 169.321,
    width: 10.854,
    height: 978.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "21px",
    height: "41px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAApCAYAAADar2JAAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB4ElEQVRIie2X23KjMBBED9iJEydbu/v/f+k4YDCXPNBtxkKJK+bVUzU1INDRjCRKTcG1FfL0OmejPL1eAErFTXKfAw6KfXI/bgO0BLbyJ0XDiwRoWAecFTuDtwnwGXgFXoBdBpwCG+AE1Bqwi9BCgFfgXf4WwGWADgH4CRwFHDRY4fI3KvlFwH/AX2Cv9k0ov1fJlZ45w1axj1lsVP5ewP8aYBemwKU3akewKrxTxoWK2e4F/BM6R3tWbPS+qynQfBkaF+xJsBwQtbfMu6QMDMoM1LFMSYn5ndjvChotDnALmv3qbnW8yx7QB/QBXWFj2rAG6oOONK6F9vLLSboGOjIdKT5JDR+B8V6oT1H7eS10ZDqSK6bTtNYgPvfvKt+wA/Ch+1OA/jrTTpCD/KgBYqa/htaCfMiPLOf0x/LTTd0J8Bm8ZhYRl32bg47Bo7UsF6hVlvFDuEANGULsw4tWJRZjp++AMIuJCLUuapiVR6MMK+Yt5Hn8EWrhdVLnnToY6tWO0AXQ0KiILbYOel4ziYWzgAeWW2hhzjRmab3ZMgkxQ72dKj1z6Vmo57PjWhFXel4wL1TDvOo9+V1ygXqB0HXLrObc5mqivs/arb+TKL6GxLNZwlKxffcflf4zxbiwL19X8cdbJCPvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "14px",
    height: "34px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAiCAYAAABvJuicAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA+klEQVQ4je3Vy07CUBDG8V9bwEsUVwafwPd/KiPgQgkCBWldnOEiqYXu+ZLJadL853ZOZjK84BlPuEGmWTVKfGHaC+gVI/TPgBuMoReRRuHgUo1zDCLSpepjkEdq/6XXpAx53gH4oyt4Ba9gG1iHdQZLaZZ0Bmf4xLoLWBzZfdi5uktMClSRao4H3GmfQXtwi584b6Vx2Tb19mAdUbeR8hCPLVFLTHb1bLHEB6ZYtUTEoRG78T4PeH4pKNJdSdezcOZRHIO11KQFvuO7STWq0zurpOJnUs1N0Abr4uRHJm2wgcOu3ISzlVT7GG+9Bo9LvEudHoaTzMli/QWnE0k6yYBlRwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "25px",
    height: "8px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAICAYAAAAMY1RdAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAoElEQVQoka3SvQrCQBAE4C96EmOhCIqWvv+T+QtqoV4RtbiLSDoTB65Y9phhZqfACCXG+Q1R6I4XajxwRwxZYI4FZnke9BB5IuKCA84BFZbYYI1JFunqpsYN2zw/GidTrCRHoSP5N6osdkLZjqVPTG2eTxJByu+KnXS0qv3pRzylo+8zbwxSA/Z5eZLi69uu5vBH3AvJTVPh0v8qHCVH8Q06wybor3DcAAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerade);
export default __webpack_public_path__ + "static/media/gerade.8065195679cad66408a8c77102717abe.svg";
export { ForwardRef as ReactComponent };